'use client';

import LegalDocument from '@/components/LegalDocument';

export default function PrivacyPolicy() {
  return <LegalDocument documentPath="/legal/privacy_policy_gdpr_en.md" />;
} 